import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import { languageTypes } from '@constants/common/languageTypes';
import type { LANGUAGE_TYPE } from '@constants/common/languageTypes';
import { ALL_USER_ROLES } from '@constants/roles/userRoleTypes.js';

export interface LanguageProps {
  name: string,
  index: number,
  text: string,
  language: string,
  user: any
  onChangeLanguage: (locale: LANGUAGE_TYPE) => void,
  onCheckKeyPress: (e: any) => void,
  impersonation
}

const LanguageSwitch = (props: LanguageProps) => {

    const {
        name,
        index,
        text,
        language,
        onChangeLanguage,
        user,
        onCheckKeyPress,
        impersonation
    } = props;

    const isShowLanguageToggle = user ? user.userActiveRole?.toUpperCase() === ALL_USER_ROLES.INDIVIDUAL || (impersonation && user.activeModuleName?.toUpperCase() === ALL_USER_ROLES.INDIVIDUAL) : true;

    return (
        <Fragment>
            <li className='usa-nav__primary-item gi-main__nav__primary-item link__language'>
                {  isShowLanguageToggle && language === languageTypes.ENGLISH &&
                    <span
                        id={`${name}_${index}`}
                        data-automation-id={`${name}_${index+1}`}
                        title="Change to Spanish"
                        role='link'
                        tabIndex={0}
                        onClick={() => onChangeLanguage('es')}
                        onKeyPress={() => onChangeLanguage('es')}
                    >
                        <FormattedMessage id = {text} />
                    </span>
                }
                { isShowLanguageToggle && language === languageTypes.SPANISH &&
                    <span
                        id={`${name}_${index+1}`}
                        data-automation-id={`${name}_${index+1}`}
                        title="Change to English"
                        role='link'
                        tabIndex={0}
                        onClick={() => onChangeLanguage('en')}
                        onKeyPress={() => onChangeLanguage('en')}>
                        <FormattedMessage id={text} />
                    </span>
                }
            </li>
        </Fragment>
    );
};

export default LanguageSwitch;